import { getValueFromMeta } from '@/utils/utils';
import _, { mapKeys, camelCase, omit } from 'lodash';
import { checkTwoValuesEqualsWithUnsignedTag } from '@/utils/utils';

export const getFileType = (fileType: any) => {
  const [_, type] = fileType.split('/');
  return type;
};

export const getGroupedProductArrByIdAndName = (arr: any[]) => {
  let groupedArr: any[] = [];

  for (let i = 0; i < arr.length; i++) {
    const v = arr[i];
    //group arr是空的 则加进去
    if (groupedArr.length === 0) {
      groupedArr.push(v);
      continue;
    }
    //arr 含有这个obj(一模一样的)
    if (isObjInCurrentArray(groupedArr, v)) {
      // console.log('===== 完全一样 v', v);
      groupedArr = groupedArr.map((x: any) => {
        if (_.isEqual(x, v)) {
          return { ...x, product_quantity: x.product_quantity * 2 };
        }
        return x;
      });
      continue;
    }
    //arr 含有这个obj(名字一样的)
    if (isObjInCurrentArrayByName(groupedArr, v)) {
      // console.log('===== 名字一样', v); //名字一样代表已经在里面了 接下来要看这个v和在里面的那个note是不是一样
      let objsToPush: any[] = [];
      groupedArr = groupedArr.map((x: any) => {
        if (
          x.product_name === v.product_name &&
          checkTwoValuesEqualsWithUnsignedTag(x.note, v.note) //两个note一样 可以直接加和
        ) {
          return {
            ...x,
            product_quantity: x.product_quantity + v.product_quantity,
          };
        }
        if (
          x.product_name === v.product_name &&
          !checkTwoValuesEqualsWithUnsignedTag(x.note, v.note) //两个note不一样 给塞进去
        ) {
          objsToPush.push(v);
        }
        return x;
      });
      if (objsToPush.length !== 0) {
        //把单独notes不同的那一些加进来
        groupedArr = [...groupedArr, ...objsToPush];
        continue;
      }
      continue;
    }
    //arr 不含有这个obj
    if (!isObjInCurrentArray(groupedArr, v)) {
      groupedArr.push(v);
      continue;
    }
  }

  return groupedArr;
};

export const getProduct = (clientData: any) => {
  let arr: any[] = [];

  clientData
    .map((x: any) => x.childrenList)
    .map((x: any) => {
      if (x) {
        x.map((y: any) => {
          arr.push({
            product_name: y.item,
            product_quantity: y.quantity,
            product_id: y.id,
            product_price: y.price,
            note: y?.pivot?.notes,
            unit_price: y.price,
            sub_total: Number(y.price) + computePrintPriceByGivenModifierGroups(y, 'subtotal'),
            total_price:
              (Number(y.price) + computePrintPriceByGivenModifierGroups(y, 'subtotal')) *
              y.quantity,
            modifier_groups: y.modifierGroups.map((group: any) => {
              const modifier_items = group.modifierItems.map((item: any) => ({
                name: item.name,
                modifier_item_id: item.id,
                quantity: item.quantity,
                unit_price: item.price,
                total_price: Number(item.price) * item.quantity,
                print_id: item.printerId,
              }));
              return {
                name: group.name,
                printer_id: group.printerId,
                modifier_group_id: group.id,
                modifier_items,
              };
            }),
          });
        });
      }
    });

  return arr;
  // return getGroupedProductArrByIdAndName(arr);
};

export const isObjInCurrentArray = (arr: any[], obj: any) => {
  let ret = false;

  for (let i = 0; i < arr.length; i++) {
    const v = arr[i];
    if (_.isEqual(v, obj)) {
      ret = true;
      break;
    }
  }

  return ret;
};

export const isObjInCurrentArrayByName = (arr: any[], obj: any) => {
  let ret: any = false;
  for (let i = 0; i < arr.length; i++) {
    const v = arr[i];
    if (v.product_name === obj.product_name) {
      ret = true;
      break;
    }
  }
  return ret;
};

export const getMix = (clientData: any) => {
  let mix = 0;

  clientData.map((x: any) => {
    const mixValue = getValueFromMeta(x.meta, 'mix');
    const number = mixValue ? Number(mixValue) : 0;

    mix = mix + number;
  });

  return mix === 0 ? 0 : mix;
};

export const getAllMixedNotes = (clientData: any) => {
  let arr: any = [];

  clientData.map((x: any) => {
    const mixNotesValue = getValueFromMeta(x.meta, 'mix_notes');
    const notes = mixNotesValue && mixNotesValue !== '' ? mixNotesValue : false;

    arr.push(notes);
  });

  return arr.filter((x: any) => x).join(', ');
};

export const getGrandTotal = (clientData: any) => {
  //用所有的originalPrice加上mix
  let ret = 0;

  clientData.map((x: any) => {
    ret += Number(x.originalTotalPrice);
  });

  return ret + getMix(clientData);
};

export const getTips = (clientData: any) => {
  let tipSummary = 0;

  clientData.map((x: any) => {
    const tipsValue = getValueFromMeta(x.meta, 'tips');
    const tipSelf = tipsValue && tipsValue !== '' ? Number(tipsValue) : 0;

    tipSummary += tipSelf;
  });
  return tipSummary;
};

export const getTotalDue = (clientData: any) => {
  return getTips(clientData) + getGrandTotal(clientData);
};

export const getRoundTotal = (paymentMethod: number, clientData: any) => {
  if (paymentMethod !== 1) {
    return undefined;
  }
  return getTotalDue(clientData).toFixed(2);
};

export const getTenderedTotal = (paymentMethod: number, inputTender: any, clientData: any) => {
  if (paymentMethod === 1) {
    return Number(inputTender);
  }
  return Number(getTotalDue(clientData));
};

export const getChange = (paymentMethod: number, inputTender: any, clientData: any) => {
  if (paymentMethod === 1) {
    return Number(
      getTenderedTotal(paymentMethod, inputTender, clientData) -
        Number(getRoundTotal(paymentMethod, clientData)),
    );
  }
  return undefined;
};

export const getGst = (clientData: any) => {
  const total = getAllDishesAmount(clientData) + getMix(clientData);
  return total / 11;
};

export const getAllDishesAmount = (clientData: any) => {
  let ret = 0;
  clientData.map((x: any) => {
    x.childrenList.map((y: any) => {
      ret += Number(y.subtotal);
    });
  });

  return ret;
};

export const getPaymentList = (paymentInfo: any) => {
  const ret = paymentInfo.map((x: any) => ({
    payment_method_name: x.info.paymentMethodName,
    processing_rate: parseFloat(getValueFromMeta(x.meta, 'rate')) / 100,
  }));
  return ret;
};

export const differentTableNumberCheck = (data: any, selectedIds: any[]) => {
  let clientData: any[] = [];

  data.map((x: any) => {
    _.forEach(selectedIds, (v: any) => {
      if (_.isEqual({ id: x.id, orderType: x.orderType }, v)) {
        clientData.push(x);
      }
    });
  });

  const refList = clientData.map((x: any) => x.referenceNumber);

  if ([...new Set(refList)].length > 1) {
    return true;
  }
  return false;
};

export const computePrintPriceByGivenModifierGroups = (data: any, key: 'subtotal') => {
  let ret = 0;
  if (key === 'subtotal') {
    data.modifierGroups.map((group: any) => {
      group.modifierItems.map((item: any) => {
        ret += Number(item.price) * Number(item.quantity);
        return item;
      });
      return group;
    });
  }
  return ret;
};
